import { Overlay, Tooltip } from "react-bootstrap";
import cx from "classnames";
import PubSub from "pubsub-js";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  gamificationTooltipActions,
  selectGamificationTooltipData,
  selectGamificationTooltipShow,
} from "../../redux/slicers/gamificationTooltipSlicer";
import { TOOLTIP_STEPS } from "./constants";
import styles from "./gamificationTooltip.module.scss";
import {
  selectAllOnboardingData,
  selectAllPropsLoaded,
  selectCuratorInitialized,
  selectOnboardingOtherMaterial,
  selectOnboardingProductMaterial,
  selectOnboardingProducts,
  selectSelectedOnboardingMaterial,
  selectSelectedOnboardingOtherMaterial,
  selectSelectedOnboardingProduct,
  selectSidebarSection,
  setOnboardingOtherMaterial,
  setOnboardingProductMaterial,
  setOnboardingProducts,
  setSelectedOnboardingMaterial,
  setSelectedOnboardingOtherMaterial,
  setSelectedOnboardingProduct,
  setSidebarSection,
} from "../../redux/slicers/admin/curatorSlicer";
import { useEffect, useState } from "react";
import { sendUnityEvent } from "../container/unityContainer";
import { UnityEvent } from "../../helpers/unityPubSub";
import {
  selectActiveTab,
  selectApplyTextureInProgress,
  setActiveTab,
  TAB_NAME,
} from "../../redux/slicers/admin/curatorStylesSlicer";
import { getAppState } from "../../redux/store";
import { errorToast } from "../../helpers/toastHelper";
import { selectSelectedObjectList } from "../../redux/slicers/admin/curatorUnityObjectSlicer";
import Hand from "../../assets/images/hand.png";
import CameraDrag from "../../assets/images/camera_drag.png";
import { debounce, isEmpty, sortBy } from "lodash";
import {
  addBlurToAll,
  blurGrid,
  isUserOnboarding,
  resetBlurAll,
  setTooltipData,
  showHideTooltip,
} from "./helpers";
import {
  apiCreateTutorialRoomState,
  apiGetTutorialRoomState,
  apiUpdateTutorialRoomState,
  apiUpdateUserDetails,
} from "../../helpers/api";
import { objectToFormData } from "../../helpers/jsHelper";
import { useUserContext } from "../../contexts/UserContext";
import { CURATOR_MENU_SECTION } from "../../redux/slicers/admin/curatorMenuPreferencesSlicer";
import { RP_TYPE } from "../../config/constant/unityConstants";
import { setOpen } from "../../redux/slicers/camera/renderPreviewPoppupSlicer";
import {
  gamifyBoardingActions,
  selectHighlightProp,
  selectIsFinalProgress,
} from "../../redux/slicers/gamifySlicer";
import {
  curatorLoadingProgressBarActions,
  selectProgressLoaded,
  selectProgressTotal,
} from "../../redux/slicers/admin/curatorLoadingProgressBarSlicer";
import { getRoomJsonFile } from "../../pages/admin/curator/getRoomJsonFile";
import {
  setGlobalHeight,
  setGlobalWidth,
} from "../../redux/slicers/camera/cameraSettings";
import { Mixpanel, MxEvent } from "../../common/Mixpanel";

export const ProgressBarLine = ({
  className,
  progress,
  designV2 = false,
  showText = false,
  style = {},
  textStyle = {},
}) => {
  return (
    <div
      className={`${cx(styles.progressBarInner, className, designV2 ? styles.designV2 : '')}`}
      style={style}>
      {showText ? (
        <span className={styles.text} style={textStyle}>
          {progress}%
        </span>
      ) : null}
      <div className={cx(styles.progressBarHighLight)} style={{ width: `${progress}%` }}></div>
    </div>
  );
};

const ProgressBar = ({ progress }) => {
  return (
    <div
      className={`${cx(
        styles.progressBar
      )} d-flex justify-content-center align-items-center`}
    >
      <ProgressBarLine progress={progress} />
      <span
        className={`${cx(styles.progressBarText)}`}
      >{`${progress}% Completed`}</span>
    </div>
  );
};

function GamificationTooltip() {
  const gamificationTooltipData = useSelector(selectGamificationTooltipData);
  const {
    coordinates,
    target,
    step,
    placement = "bottom",
    showArrow = true,
  } = gamificationTooltipData;
  const curatorInitialized = useSelector(selectCuratorInitialized);
  const showTooltip = useSelector(selectGamificationTooltipShow);
  const allPropsLoaded = useSelector(selectAllPropsLoaded);
  const selectedProps = useSelector(selectSelectedObjectList);
  const dispatch = useDispatch();
  const allOnboardingData = useSelector(selectAllOnboardingData);
  const {
    tutorial_room_id,
    room_id,
    final_camera_angle,
    name,
    other_object_data,
    toolTipPosition,
  } = allOnboardingData;
  const selectedStep = TOOLTIP_STEPS[step];
  const { title = "", content = "", icon = "", progress = 0 } = selectedStep;
  const userCtx = useUserContext();
  const [tooltipTargetKey, setTooltipTargetKey] = useState(null);
  const { currentUser, updateUserData } = userCtx;
  const isOnboardingState = isUserOnboarding();
  const sidebarSection = useSelector(selectSidebarSection);
  const activeTab = useSelector(selectActiveTab);
  const isActive = useSelector(selectIsFinalProgress);
  const onboardingProductMaterial = useSelector(
    selectOnboardingProductMaterial
  );
  const onboardingOtherMaterial = useSelector(selectOnboardingOtherMaterial);
  const onboardingProducts = useSelector(selectOnboardingProducts);
  const selectedOnboardingMaterial = useSelector(
    selectSelectedOnboardingMaterial
  );
  const selectedOnboardingProduct = useSelector(
    selectSelectedOnboardingProduct
  );
  const selectedOnboardingOtherMaterial = useSelector(
    selectSelectedOnboardingOtherMaterial
  );
  const totalCuratorProgress = useSelector(selectProgressTotal);
  const totalCuratorLoaded = useSelector(selectProgressLoaded);
  const finalCuratorProgress = Math.min(
    Math.floor((totalCuratorLoaded / totalCuratorProgress) * 100),
    100
  );
  const [timer, setTimer] = useState(null);
  const propToBeHighlighted = useSelector(selectHighlightProp);
  const [tooltipCoordinatesData, setTooltipCoordinatesData] = useState(null);
  const [mounted, setMounted] = useState(false);
  const isWall = other_object_data?.isWall || false;
  const [mxStepStatus, setMXStepStatus] = useState({
    Step3: false,
    Step4: false,
    Step5: false,
    Step6: false,
    Step7: false,
    Step8: false,
  });

  useEffect(() => {
    if (!isOnboardingState || !currentUser || isActive) return;
    setTooltipData({
      step: currentUser?.user?.other_info?.gamifyOnBoarding?.curatorStep,
    });
    return () => {
      resetBlurAll();
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  useEffect(() => {
    const listener = debounce(() => {
      getObjectScreenPosition(tooltipCoordinatesData);
    }, 60);
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
      listener.cancel();
    };
  }, [tooltipCoordinatesData]);

  useEffect(() => {
    if (!isOnboardingState || !currentUser || isActive) return;
    let message = "Loading...";
    if (finalCuratorProgress > 0 && finalCuratorProgress < 33) {
      message = "imagine.io is your 3D super power.";
    } else if (finalCuratorProgress > 34 && finalCuratorProgress < 66) {
      message = "Get ready for your space - we're setting it up!";
    } else if (finalCuratorProgress > 67 && finalCuratorProgress <= 100) {
      message =
        "You've dreamed it, now let's make it a reality. You're all set and ready to go!";
    }
    dispatch(curatorLoadingProgressBarActions.setOnboardingMessage(message));
  }, [totalCuratorProgress, totalCuratorLoaded]);

  useEffect(() => {
    if (
      !isOnboardingState ||
      !currentUser ||
      !allPropsLoaded ||
      !curatorInitialized ||
      isActive
    )
      return;
    handleSteps(step);
    updateStep(step);
  }, [
    step,
    currentUser,
    allPropsLoaded,
    curatorInitialized,
    activeTab,
    sidebarSection,
  ]);

  useEffect(() => {
    if (
      !allPropsLoaded ||
      !curatorInitialized ||
      !isOnboardingState ||
      !progress ||
      !propToBeHighlighted ||
      selectedProps.length
    )
      return;
    if (progress <= 60) {
      const highlightObj = JSON.parse(propToBeHighlighted);
      const data = JSON.parse(highlightObj);
      let { objectName } = data;
      if (
        step === "ADD_WALL_FINISH" ||
        step === "QUICK_MESSAGE" ||
        step === "CLICK_ARROW"
      ) {
        objectName = other_object_data?.name;
      }
      const highlightObjData = [
        {
          objectName: objectName,
          ObjectSelectionMode: "Style",
          clickedObjectName: objectName,
        },
      ];
      console.warn("SelectObjectReceiver", data);
      sendUnityEvent(
        "OnBoardingRoomModule",
        "SelectObjectReceiver",
        JSON.stringify(highlightObjData)
      );
    } else {
      dispatch(gamifyBoardingActions.setHighlightProp(null));
    }
  }, [step, progress, propToBeHighlighted, allPropsLoaded, curatorInitialized]);

  useEffect(() => {
    if (
      !isOnboardingState ||
      !allPropsLoaded ||
      !curatorInitialized ||
      isActive
    ) {
      return;
    }
    dispatch(gamificationTooltipActions.show());
    setTooltipTargetKey(null);
    let timer = null;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      setTooltipTargetKey(Math.random());
      if (!mounted) setMounted(true);
    }, getDelayVal(step, target));
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [allPropsLoaded, curatorInitialized, step]);

  useEffect(() => {
    if (!isOnboardingState) return;
    let timer = null;

    if (final_camera_angle) {
      dispatch(setGlobalWidth(final_camera_angle?.resoX));
      dispatch(setGlobalHeight(final_camera_angle?.resoY));
    }

    const OnDragCompletedReceiverCallback = (_) => {
      console.warn("OnDragCompletedReceiverCallback", step);
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (step === "CLICK_AND_DRAG_TO_ROTATE") {
          setTooltipData({
            step: "CLICK_HERE_TO_CAMERA",
          });
          sendCameraAngleToUnity();
        }
      }, 3000);
    };
    const OnReceiveObjectScreenPositionCallback = (_, data) => {
      console.warn("onReceiveObjectScreenPositionCallback", data);
      if (data.length) {
        const { x, y } = data[0];
        const unityEle = document.querySelector("#unityCanvasContainer");
        const unityWidth = unityEle.offsetWidth;
        const unityHeight = unityEle.offsetHeight;
        const coordinates = {
          left: unityWidth * parseFloat(x).toFixed(3) + 96,
          top: unityHeight - unityHeight * parseFloat(y).toFixed(3) + 56,
        };
        console.warn(
          "coordinates",
          {
            unityWidth,
            unityHeight,
            x,
            y,
          },
          coordinates
        );
        setTooltipData({
          coordinates: coordinates,
        });
      }
    };
    const OnReplacePropOperationCompletedCallback = (_, data) => {
      if (step === "SELECT_PRODUCT" && data) {
        console.warn("replace prop data", data);
        setTooltipData({
          step: "CONGRATULATIONS",
        });
        dispatch(gamifyBoardingActions.setHighlightProp(data));
      }
    };
    PubSub.subscribe(
      UnityEvent.OnReceiveObjectScreenPosition,
      OnReceiveObjectScreenPositionCallback
    );
    PubSub.subscribe(
      UnityEvent.OnDragCompletedReceiver,
      OnDragCompletedReceiverCallback
    );
    PubSub.subscribe(
      UnityEvent.OnReplacePropOperationCompleted,
      OnReplacePropOperationCompletedCallback
    );
    return () => {
      PubSub.unsubscribe(OnDragCompletedReceiverCallback);
      PubSub.unsubscribe(OnReceiveObjectScreenPositionCallback);
      PubSub.unsubscribe(OnReplacePropOperationCompletedCallback);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [step, allOnboardingData]);

  useEffect(() => {
    if (!isOnboardingState) return;
    const OnMaterialApplyOperationCompletedCallback = (_) => {
      console.warn("in apply material callback");
      updateStepOnMaterialApply();
    };
    PubSub.subscribe(
      UnityEvent.OnMaterialApplyOperationCompleted,
      OnMaterialApplyOperationCompletedCallback
    );
    return () => {
      PubSub.unsubscribe(OnMaterialApplyOperationCompletedCallback);
    };
  }, [
    step,
    currentUser,
    selectedOnboardingMaterial,
    selectedOnboardingOtherMaterial,
  ]);

  useEffect(() => {
    if (!allPropsLoaded || !curatorInitialized || !isOnboardingState) {
      return;
    }
    const objectName = other_object_data?.name;
    const isWallSelected = selectedProps?.find(
      (val) => val.objectName === objectName
    );
    if (step === "CLICK_ON_WALL" && !isEmpty(isWallSelected)) {
      selectMaterialTab();
    }
  }, [
    allPropsLoaded,
    curatorInitialized,
    selectedProps,
    step,
    allOnboardingData,
  ]);

  const updateStepOnMaterialApply = () => {
    if (step === "ADD_WALL_FINISH" || step === "ADD_FINISH") {
      setTooltipData({
        step: step === "ADD_WALL_FINISH" ? "QUICK_MESSAGE" : "GREAT_JOB",
      });
    }
    showHideTooltip(currentUser, updateUserData, {
      gamifyOnBoarding: {
        ...currentUser?.user?.other_info?.gamifyOnBoarding,
        data: {
          ...currentUser?.user?.other_info?.gamifyOnBoarding?.data,
          selectedOnboardingMaterial: selectedOnboardingMaterial,
          selectedOnboardingOtherMaterial: selectedOnboardingOtherMaterial,
        },
      },
    });
    createOrUpdateTutorialRoomState();
  };

  const createOrUpdateTutorialRoomState = async () => {
    const memberId = currentUser?.id;
    const allRooms = await apiGetTutorialRoomState();
    if (memberId && tutorial_room_id && allRooms) {
      const results = allRooms.results.filter(
        (a) =>
          a.member === memberId && a.tutorialroom === Number(tutorial_room_id)
      );
      const roomJson = (await getRoomJsonFile())?.raw;
      if(!roomJson) return;
      roomJson.highlightProp = selectHighlightProp(getAppState());
      const room_json_data = JSON.stringify(roomJson);
      const formData = new FormData();
      const blob = new Blob([room_json_data], { type: "application/json" });
      if (!results.length) {
        formData.append("tutorialroom", tutorial_room_id);
        formData.append("json_file", blob, "json_file.json");
        await apiCreateTutorialRoomState(formData);
      }
      if (results.length && results?.[0]?.id) {
        formData.append("json_file", blob, "json_file.json");
        await apiUpdateTutorialRoomState(results?.[0]?.id, formData);
      }
    }
  };

  const updateStep = async (step) => {
    const { user } = currentUser;
    const { other_info } = user;
    const curatorStep = other_info?.gamifyOnBoarding?.curatorStep;
    const gamifyData = other_info?.gamifyOnBoarding?.data;
    const currentStep = step;
    const tutorialRoom = gamifyData?.tutorial_room_id
      ? gamifyData?.tutorial_room_id
      : tutorial_room_id;
    const room = gamifyData?.room_id ? gamifyData?.room_id : room_id;
    const productMaterial = !isEmpty(gamifyData?.onboardingProductMaterial)
      ? gamifyData?.onboardingProductMaterial
      : onboardingProductMaterial;
    const otherMaterial = !isEmpty(gamifyData?.onboardingOtherMaterial)
      ? gamifyData?.onboardingOtherMaterial
      : onboardingOtherMaterial;
    const allProducts = !isEmpty(gamifyData?.onboardingProducts)
      ? gamifyData?.onboardingProducts
      : onboardingProducts;
    const selectedMaterial = !isEmpty(selectedOnboardingMaterial)
      ? selectedOnboardingMaterial
      : gamifyData?.selectedOnboardingMaterial;
    const selectedProduct = !isEmpty(gamifyData?.selectedOnboardingProduct)
      ? gamifyData?.selectedOnboardingProduct
      : selectedOnboardingProduct;
    const selectedOtherMaterial = !isEmpty(selectedOnboardingOtherMaterial)
      ? selectedOnboardingOtherMaterial
      : gamifyData?.selectedOnboardingOtherMaterial;

    switch (step) {
      case "STYLE_CLICK":
        if (!mxStepStatus.Step3) {
          Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_STEP_3, {
            "Tutorial room id": tutorialRoom,
            "Room id": room,
            "Selected prop id": gamifyData?.selectedOnboardingProduct?.id,
            "Selected prop blender id":
              gamifyData?.selectedOnboardingProduct?.blender_id,
            "Selected prop name id":
              gamifyData?.selectedOnboardingProduct?.name,
          });
        }
        setMXStepStatus((prevState) => ({
          ...prevState,
          Step3: true,
        }));
        break;

      case "CLICK_ON_WALL":
        if (!mxStepStatus.Step4) {
          Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_STEP_4, {
            "Tutorial room id": tutorialRoom,
            "Room id": room,
            "Selected texture id": gamifyData?.selectedOnboardingMaterial?.id,
            "Selected texture name id":
              gamifyData?.selectedOnboardingMaterial?.name,
          });
        }
        setMXStepStatus((prevState) => ({
          ...prevState,
          Step4: true,
        }));
        break;

      case "CLICK_AND_DRAG_TO_ROTATE":
        if (!mxStepStatus.Step5) {
          Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_STEP_5, {
            "Tutorial room id": tutorialRoom,
            "Room id": room,
            "Selected texture id":
              gamifyData?.selectedOnboardingOtherMaterial?.id,
            "Selected texture name id":
              gamifyData?.selectedOnboardingOtherMaterial?.name,
          });
        }
        setMXStepStatus((prevState) => ({
          ...prevState,
          Step5: true,
        }));
        break;

      case "CLICK_HERE_TO_CAMERA":
        if (!mxStepStatus.Step6) {
          Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_STEP_6, {
            "Tutorial room id": tutorialRoom,
            "Room id": room,
          });
        }
        setMXStepStatus((prevState) => ({
          ...prevState,
          Step6: true,
        }));
        break;

        case "ONE_STEP_TO_GO":
          if (!mxStepStatus.Step7) {
            Mixpanel.track(true, MxEvent.GAMIFY_ONBOARDING_STEP_7, {
              "Tutorial room id": tutorialRoom,
              "Room id": room,
            });
          }
          setMXStepStatus((prevState) => ({
            ...prevState,
            Step7: true,
          }));
          break;

      default:
        break;
    }

    dispatch(setOnboardingProductMaterial(productMaterial));
    dispatch(setOnboardingProducts(allProducts));
    dispatch(setSelectedOnboardingMaterial(selectedMaterial));
    dispatch(setSelectedOnboardingProduct(selectedProduct));
    dispatch(setSelectedOnboardingOtherMaterial(selectedOtherMaterial));
    dispatch(setOnboardingOtherMaterial(otherMaterial));
    if (currentStep === curatorStep) {
      return;
    }
    const curatorData = {
      ...gamifyData,
      tutorial_room_id: tutorialRoom,
      room_id: room,
      onboardingProducts: allProducts,
      selectedOnboardingProduct: selectedProduct,
      onboardingProductMaterial: productMaterial,
      selectedOnboardingMaterial: selectedMaterial,
      onboardingOtherMaterial: otherMaterial,
      selectedOnboardingOtherMaterial: selectedOtherMaterial,
    };
    const selectedStep = TOOLTIP_STEPS[currentStep];
    const { mainStep } = selectedStep;
    const data = {
      ...other_info,
      gamifyOnBoarding: {
        ...other_info?.gamifyOnBoarding,
        data: curatorData,
        curatorStep: currentStep,
        step: mainStep,
      },
    };
    const payload = {
      other_info: JSON.stringify(data),
    };
    setTooltipData({
      step: currentStep,
    });
    const formData = objectToFormData(payload);
    const res = await apiUpdateUserDetails(formData);
    if (res) {
      updateUserData({
        ...currentUser,
        user: {
          ...currentUser?.user,
          other_info: {
            ...currentUser?.user?.other_info,
            ...res?.other_info,
          },
        },
      });
    }
    createOrUpdateTutorialRoomState();
  };

  const getDelayVal = (step, target) => {
    if (!target) {
      return 0;
    }
    if (step === "PRODUCE_IMAGE") {
      return 750;
    }
    if (mounted) {
      return 0;
    }
    return 250;
  };

  const highlightAndSelectObject = (objectName) => {
    if (!objectName) {
      return;
    }
    const data = {
      objectName: objectName,
    };
    let tooltipData = null;
    const initialPosition = { x: 0, y: 0, z: 0 };
    if (step === "SELECT_ANY_PROP") {
      tooltipData = toolTipPosition || initialPosition;
    } else {
      tooltipData = other_object_data?.toolTipPosition || initialPosition;
    }
    setTooltipCoordinatesData(tooltipData);
    sendUnityEvent(
      "OnBoardingRoomModule",
      "HighlightObjectReceiver",
      JSON.stringify(data)
    );
    getObjectScreenPosition(tooltipData);
  };

  const getObjectScreenPosition = (data) => {
    if (!data) {
      return;
    }
    sendUnityEvent(
      "OnBoardingRoomModule",
      "GetObjectScreenPositionReceiver",
      JSON.stringify(data)
    );
  };

  const showHideSidebar = (step) => {
    // show products sidebar
    if (step === "SELECT_PRODUCT") {
      toggleSidebar(CURATOR_MENU_SECTION.PRODUCTS);
    }
    // show style sidebar with textures
    else if (
      step === "ADD_FINISH" ||
      step === "GREAT_JOB" ||
      step === "CLICK_ON_WALL"
    ) {
      toggleSidebar(CURATOR_MENU_SECTION.STYLE);
      toggleTab(TAB_NAME.TEXTURES);
    }
    // show style sidebar with materials
    else if (
      step === "ADD_WALL_FINISH" ||
      step === "QUICK_MESSAGE" ||
      step === "CLICK_ARROW"
    ) {
      toggleSidebar(CURATOR_MENU_SECTION.STYLE);
      toggleTab(TAB_NAME.MATERIALS);
    }
    // show camera sidebar
    else if (step === "ADD_SAVE_CAMERA" || step === "GIVE_NAME_AND_SAVE") {
      toggleTab(null);
      toggleSidebar(CURATOR_MENU_SECTION.CAMERAS);
    }
    // show produce image dialog
    else if (step === "PRODUCE_IMAGE") {
      toggleSidebar(null);
      dispatch(setOpen(RP_TYPE.PREVIEW));
    }
    // hide popups in other cases
    else {
      toggleSidebar(null);
      toggleTab(null);
      dispatch(setOpen(false));
    }
  };

  const toggleSidebar = (menuName) => {
    if (sidebarSection !== menuName) {
      dispatch(setSidebarSection(menuName));
    }
  };

  const toggleTab = (tabName) => {
    if (activeTab !== tabName) {
      dispatch(setActiveTab(tabName));
    }
  };

  const showHideArrows = (step) => {
    let showArrow = false;
    // show tooltip arrow in this cases
    if (
      step === "CONGRATULATIONS" ||
      step === "GREAT_JOB" ||
      step === "QUICK_MESSAGE" ||
      step === "ONE_STEP_TO_GO"
    ) {
      showArrow = false;
    }
    // hide tooltip arrow in other cases
    else {
      showArrow = true;
    }
    setTooltipData({
      showArrow: showArrow,
    });
  };

  const tooltipArrowPosition = (step) => {
    let placement = "bottom";
    // bottom arrow
    if (
      step === "SELECT_ANY_PROP" ||
      step === "PRODUCE_IMAGE" ||
      step === "RENDER" ||
      step === "CLICK_AND_DRAG_TO_ROTATE" ||
      (step === "CLICK_ON_WALL" && !isWall)
    ) {
      placement = "bottom";
    }
    // left arrow
    else if (step === "REPLACE_PROP") {
      placement = "left";
    }
    // right arrow
    else {
      placement = "right";
    }
    setTooltipData({
      placement: placement,
    });
  };

  const hideShowOverlay = (step) => {
    if (
      step === "REPLACE_PROP" ||
      step === "SELECT_PRODUCT" ||
      step === "STYLE_CLICK" ||
      step === "ADD_FINISH" ||
      step === "ADD_SAVE_CAMERA" ||
      step === "CLICK_HERE_TO_CAMERA" ||
      step === "GIVE_NAME_AND_SAVE" ||
      step === "RENDER" ||
      step === "PRODUCE_IMAGE"
    ) {
      addBlurToAll();
    }
    if (
      step === "SELECT_ANY_PROP" ||
      step === "CONGRATULATIONS" ||
      step === "GREAT_JOB" ||
      step === "CLICK_ON_WALL" ||
      step === "QUICK_MESSAGE" ||
      step === "CLICK_ARROW" ||
      step === "CLICK_AND_DRAG_TO_ROTATE" ||
      step === "ONE_STEP_TO_GO" ||
      step === "ADD_WALL_FINISH"
    ) {
      resetBlurAll();
    }
    if (
      step === "GREAT_JOB" ||
      step === "CLICK_ON_WALL" ||
      step === "QUICK_MESSAGE" ||
      step === "CLICK_ARROW" ||
      step === "ADD_WALL_FINISH"
    ) {
      blurGrid();
    }
  };

  const setCoordinatesAndTarget = (step) => {
    if (
      step === "SELECT_ANY_PROP" ||
      step === "CONGRATULATIONS" ||
      step === "GREAT_JOB" ||
      step === "CLICK_ON_WALL" ||
      step === "QUICK_MESSAGE" ||
      step === "ONE_STEP_TO_GO" ||
      step === "CLICK_AND_DRAG_TO_ROTATE"
    ) {
      setTooltipData({
        target: null,
      });
    }
    if (
      step !== "SELECT_ANY_PROP" &&
      step !== "REPLACE_PROP" &&
      step !== "CLICK_ON_WALL"
    ) {
      setTooltipData({
        coordinates: null,
      });
    }
  };

  const stopBlinking = (progress) => {
    if (progress > 60) {
      sendUnityEvent("OnBoardingRoomModule", "StopBlinkingReceiver");
    }
  };

  // to start or stop the camera movement
  const startStopCamera = (step) => {
    if (step === "CLICK_AND_DRAG_TO_ROTATE") {
      sendUnityEvent(
        "OnBoardingRoomModule",
        "SetCameraMovementStateReceiever",
        "true"
      );
    }
  };

  // send unity event
  const sendCameraAngleToUnity = () => {
    sendUnityEvent(
      "CameraModule",
      "SetFinalCameraReceiver",
      JSON.stringify(final_camera_angle)
    );
  };

  const handleSteps = (step) => {
    hideShowOverlay(step);
    showHideArrows(step);
    setCoordinatesAndTarget(step);
    tooltipArrowPosition(step);
    showHideSidebar(step);
    startStopCamera(step);
    stopBlinking(progress);
    if (
      (step === "SELECT_ANY_PROP" ||
        step === "SELECT_PRODUCT" ||
        step === "REPLACE_PROP") &&
      !selectedProps.length
    ) {
      setTimeout(() => {
        highlightAndSelectObject(name);
      }, 150);
    }
    if (step === "CONGRATULATIONS") {
      showStepOnDelay("STYLE_CLICK");
    }
    if (step === "GREAT_JOB") {
      showStepOnDelay("CLICK_ON_WALL");
    }
    if (step === "CLICK_ON_WALL") {
      const objectName = other_object_data?.name;
      setTimeout(() => {
        highlightAndSelectObject(objectName);
      }, 150);
    }
    if (step === "QUICK_MESSAGE") {
      showStepOnDelay("CLICK_ARROW");
    }
    if (step === "ONE_STEP_TO_GO") {
      showStepOnDelay("RENDER");
    }
  };

  const selectMaterialTab = () => {
    const loading = selectApplyTextureInProgress(getAppState());
    if (loading) {
      errorToast("Please wait, previous texture is still in progress", {
        toastId: "TEXTURE_APPLY_IN_PROGRESS_TAB_SWITCH",
      });
      return;
    }
    const materialData = other_object_data?.other_object_material_data?.map(
      (val) => {
        const obj = {
          ...val.material_data,
          is_disabled: val.is_disabled,
          mainId: val.id,
        };
        return obj;
      }
    );
    const finalData = sortBy(materialData, ["is_disabled"]);
    dispatch(setOnboardingOtherMaterial(finalData));
    setTooltipData({
      step: "ADD_WALL_FINISH",
    });
  };

  const showStepOnDelay = (step) => {
    const callBack = () => {
      const updateObj = {
        step: step,
      };
      setTooltipData(updateObj);
    };
    if (timer) {
      clearTimeout(timer);
    }
    const timeout = setTimeout(() => {
      callBack();
    }, 5000);
    setTimer(timeout);
  };

  const getTooltipContent = () => {
    const isLightTitle =
      step === "CONGRATULATIONS" ||
      step === "GREAT_JOB" ||
      step === "QUICK_MESSAGE" ||
      step === "ONE_STEP_TO_GO";
    return (
      <>
        {title && (
          <div className="d-flex justify-content-start align-items-center">
            {icon && (
              <img src={icon} title={title} className={cx(styles.icon)} />
            )}
            <div
              className={cx(
                "customTooltipTitle",
                isLightTitle && "customTooltipLightTitle"
              )}
            >
              {!isWall ? title.replaceAll("wall", "floor") : title}
            </div>{" "}
          </div>
        )}
        {content && (
          <div
            className={cx(
              "customTooltipText",
              isLightTitle && "customTooltipLightText"
            )}
          >
            {!isWall ? content.replaceAll("wall", "floor") : content}
          </div>
        )}
      </>
    );
  };

  const getTooltip = () => {
    if (target && tooltipTargetKey) {
      return (
        <Overlay
          key={tooltipTargetKey}
          target={target}
          show={true}
          placement={placement}
        >
          {({ ...props }) => (
            <Tooltip
              {...props}
              className={cx("customTooltip", {
                customTooltipBottom: placement === "top" && showArrow,
                customTooltipTop: placement === "bottom" && showArrow,
                customTooltipLeft: placement === "right" && showArrow,
                customTooltipRight: placement === "left" && showArrow,
                customTooltipSpacing: placement === "bottom" && showArrow,
              })}
              style={{
                width: selectedStep?.styles?.width,
                ...props.style,
                top:
                  step === "SELECT_PRODUCT"
                    ? "calc(-50% + 205px)"
                    : step === "ADD_FINISH" || step === "ADD_WALL_FINISH"
                    ? "calc(-50% + 315px)"
                    : props?.style?.top,
              }}
            >
              {getTooltipContent()}
            </Tooltip>
          )}
        </Overlay>
      );
    }
    if (tooltipTargetKey)
      return ReactDOM.createPortal(
        <div
          className={cx("customTooltip", {
            customTooltipBottom: placement === "bottom" && showArrow,
            customTooltipTop: placement === "top" && showArrow,
            customTooltipLeft: placement === "left" && showArrow,
            customTooltipRight: placement === "right" && showArrow,
            hideTooltip:
              (step === "CLICK_ON_WALL" || step === "SELECT_ANY_PROP") &&
              !coordinates,
          })}
          style={{
            top: `${coordinates?.top}px`,
            left: `${coordinates?.left}px`,
            ...selectedStep?.styles,
            transform:
              !isWall && step === "CLICK_ON_WALL"
                ? "translate(-50%, -100%)"
                : selectedStep?.styles.transform,
          }}
        >
          {getTooltipContent()}
        </div>,
        document.querySelector("body")
      );
    return null;
  };

  if (!showTooltip || !isOnboardingState || isActive) {
    return null;
  }

  return (
    <>
      <ProgressBar progress={progress} />
      {getTooltip()}
      {step === "CLICK_AND_DRAG_TO_ROTATE" && (
        <div
          className={`${cx(
            styles.cameraRotate
          )} d-flex flex-column justify-content-center align-items-center`}
        >
          <img src={CameraDrag} title="Drag" />
          <img src={Hand} title="Hand" />
          <Tooltip
            className={cx("customTooltip customTooltipTop")}
            style={{
              ...selectedStep?.styles,
            }}
          >
            {getTooltipContent()}
          </Tooltip>
        </div>
      )}
    </>
  );
}

export default GamificationTooltip;
